import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import { TooltipIcon } from "frontend/app-header/left-header/menu/icons";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import styles from "./label.module.css";
import { CSSProperties, useRef } from "react";

type MenuLabelProps = {
  icon?: React.ReactNode;
  label: string | React.ReactNode | React.ReactElement;
  disabled?: boolean;
  tooltip?: string | React.ReactNode | React.ReactElement;
  rightIcon?: string | React.ReactNode | React.ReactElement;
  style?: CSSProperties;
};

export const MenuLabel = ({ icon, label, tooltip, rightIcon, disabled, style }: MenuLabelProps) => {
  const iconRef = useRef<any>(null);
  const iconHover = useHover(iconRef);

  return (
    <HeaderActionButton className={styles.label} disabled={disabled} style={style}>
      <div className={styles.labelContent}>
        {icon}
        {label}
      </div>
      {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}
      {tooltip && (
        <>
          <TooltipIcon ref={iconRef} />
          {iconHover && (
            <Tooltip label={tooltip} relativeTo={iconRef} design="monday" customStyle={{ borderRadius: 3 }} />
          )}
        </>
      )}
    </HeaderActionButton>
  );
};
